const DESKTOP_QUERY = '(min-width: 990px)';
const initializedSections = new WeakSet();

class RinaProductGalleryScroll {
  constructor(section) {
    this.section = section;
    this.blockedUntil = 0;

    this.handleWheel = this.handleWheel.bind(this);

    section.addEventListener('wheel', this.handleWheel, {
      passive: false,
    });
  }

  getGallery(event) {
    if (!(event.target instanceof Element)) return null;

    return event.target.closest(
      'media-gallery.media-gallery--carousel'
    );
  }

  getSlideshow(gallery) {
    return gallery?.querySelector('slideshow-component');
  }

  handleWheel(event) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;

    const gallery = this.getGallery(event);

    if (!gallery) return;

    const slideshow = this.getSlideshow(gallery);

    if (!slideshow) return;

    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    const slides = slideshow.querySelectorAll('slideshow-slide');

    if (slides.length <= 1) return;

    const direction = event.deltaY > 0 ? 1 : -1;
    const currentIndex = Number(slideshow.current || 0);
    const nextIndex = currentIndex + direction;
    const lastIndex = slides.length - 1;
    const now = Date.now();

    if (now < this.blockedUntil) {
      event.preventDefault();
      return;
    }

    /*
      First image + scroll up:
      allow normal page scroll.

      Last image + scroll down:
      allow normal page scroll.
    */
    if (nextIndex < 0 || nextIndex > lastIndex) {
      return;
    }

    event.preventDefault();

    this.blockedUntil = now + 450;

    if (typeof slideshow.select === 'function') {
      slideshow.select(
        nextIndex,
        event,
        { animate: true }
      );
    }
  }
}

const initRinaProductGalleries = (root = document) => {
  const sections = [];

  if (
    root instanceof Element &&
    root.matches('.product-information')
  ) {
    sections.push(root);
  }

  sections.push(
    ...root.querySelectorAll('.product-information')
  );

  sections.forEach((section) => {
    if (initializedSections.has(section)) return;

    initializedSections.add(section);

    new RinaProductGalleryScroll(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initRinaProductGalleries()
  );
} else {
  initRinaProductGalleries();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initRinaProductGalleries(event.target);
  }
);